import { BaseViewStore } from 'core/stores';
import { action } from "mobx";
import { ModalParams } from 'core/models';
import { FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore } from 'application/facility-order-new-flow-insurance/stores';

class FacilityOrderPatientNewFlowInsuranceEditModalStore extends BaseViewStore {
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;

        this.patient = componentProps.modalParams.data.patient;
        this.refreshInsuranceData = this.modalParams.data.refreshInsuranceData;
        this.disableEdit = this.modalParams.data.disableEdit;
        this.changeFacilityOrderPatientInsuranceStatus = this.modalParams.data.changeFacilityOrderPatientInsuranceStatus;
        this.facilityOrderPatient = this.modalParams.data.facilityOrderPatient;
        this.facilityOrderTemplates = this.modalParams.data.facilityOrderTemplates;
        this.fetchPatientTemplates = this.modalParams.data.fetchPatientTemplates;

        this.facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore = new FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore(this.rootStore, { patient: this.patient, refreshInsuranceData: this.refreshInsuranceData, openRelationshipChangeModal: async () => await this.openRelationshipChangeModal(), disableEdit: this.disableEdit, changeFacilityOrderPatientInsuranceStatus: this.changeFacilityOrderPatientInsuranceStatus ? () => this.changeFacilityOrderPatientInsuranceStatus() : null, facilityOrderPatient: this.facilityOrderPatient, facilityOrderTemplates: this.facilityOrderTemplates, fetchPatientTemplates: this.fetchPatientTemplates });
        this.relationshipChangeModal = new ModalParams({});
    }

    @action.bound
    async openRelationshipChangeModal() {
        this.relationshipChangeModal.open({ patientKey: this.patient.patientKey });
    }
}

export default FacilityOrderPatientNewFlowInsuranceEditModalStore;
